import { useTheme } from "expo-router/react-navigation";
import { ColorValue } from "react-native";

/**
 * React Navigation's theme types each color as `ColorValue`
 * (`string | OpaqueColorValue`) so callers can pass `PlatformColor`. Our theme
 * only ever uses CSS string colors, but chart libraries (victory-native / Skia,
 * recharts) require plain `string`s. This hook narrows the theme palette to
 * strings so those colors can be passed through without per-call assertions.
 */
export interface ThemeColors {
  primary: string;
  background: string;
  card: string;
  text: string;
  border: string;
  notification: string;
}

const toColorString = (color: ColorValue): string =>
  typeof color === "string" ? color : String(color);

export const useThemeColors = (): ThemeColors => {
  const { colors } = useTheme();

  return {
    primary: toColorString(colors.primary),
    background: toColorString(colors.background),
    card: toColorString(colors.card),
    text: toColorString(colors.text),
    border: toColorString(colors.border),
    notification: toColorString(colors.notification),
  };
};
